import Component from './thanks'

export default Component